import React from 'react'
import { Wrapper } from '@googlemaps/react-wrapper'

import CustomMap from './custom-map'
import type { GarageMapProps } from './types'
import '../../styles/map-styles.scss'

export default function GarageMap({
    garageList,
    isActive = true,
    selectedId,
    setSelectedId,
    hoverPoint,
    setHoverPoint,
    searchLocationPoint,
    loadingGarageAvailability,
    garagesAvailableLater,
    currency,
    pwa = false,
    navigateToGarage,
}: GarageMapProps) {
    return (
        <Wrapper
            apiKey={import.meta.env.VITE_GOOGLE_MAPS_KEY}
            version="weekly"
            libraries={['places', 'marker']}
        >
            <CustomMap
                garageList={garageList}
                isActive={isActive}
                garagesAvailableLater={garagesAvailableLater}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
                hoverPoint={hoverPoint}
                setHoverPoint={setHoverPoint}
                searchLocationPoint={searchLocationPoint}
                loadingGarageAvailability={loadingGarageAvailability}
                currency={currency}
                pwa={pwa}
                navigateToGarage={navigateToGarage}
            />
        </Wrapper>
    )
}
